import { ReactElement } from "react";
import { EventGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { Highlight } from "client/Components";
import { generateTrackingId } from "client/Misc/utils";
import { useHighlights } from "./useHighlights";
import { TimeZone } from "client/DateAndTime/timezones";
import { EventListItem } from "client/Features/Hub/Events/ListItem/EventListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { useEventNavigationHandler } from "../../../Navigation/useEventNavigationHandler";

export type EventItemViewProps = {
	item: EventGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	timezone: TimeZone;
	tabIndex: number;
};

export const EventItemView = (props: EventItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		timezone,
		tabIndex
	} = props;

	const {
		event,
		hitHighlights
	} = item;

	const highlights: Map<string, Highlight> = useHighlights(hitHighlights);

	const openHandler: () => void = useEventNavigationHandler({
		id: event.id,
		searchResult: item,
		itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("event-item", `|${event.id}`)}
			onClick={openHandler}
		>
			<EventListItem
				title={event.title}
				authorName={event.author?.name}
				categoryName={event.category?.name}
				media={event.media}
				startDate={event.startDate}
				timezone={timezone}
				trackingId={generateTrackingId("event-item-result-list-item", `|${event.id}`)}
				highlights={{ title: highlights.get("event.title") }}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};

EventItemView.displayName = "EventItemView";
